let clickObj = {
  coverBoostOffered: false,
  coverBoostClicks: false,
};

export const useCoverBoostTrackers = ({ root }) => {
  let previouslyClicked = '';

  const setMoreInfoClick = async (coverBoostProducts) => {
    // Reset the click obj every time moreInfo is clicked
    clickObj = {
      coverBoostOffered: false,
      coverBoostClicks: false,
    };

    clickObj.companyName = coverBoostProducts[0].brokerFullName;

    const optionalExtrasFirst = coverBoostProducts[0].optionalExtra;
    clickObj.totalOptExPrice0 = Object.keys(optionalExtrasFirst).filter(k => optionalExtrasFirst[k].included === 'Y').length;

    if (coverBoostProducts.length > 1) {
      clickObj.coverBoostOffered = true;

      coverBoostProducts.forEach((product, idx) => {
        clickObj[`companyProduct${idx}`] = product.productName || '-';
        clickObj[`price${idx}`] = product.annualPremium.toFixed(2) || '-';
        clickObj[`totalOptExPrice${idx}`] = Object.keys(product.optionalExtra).filter(k => product.optionalExtra[k].included === 'Y').length || '-';
      });
    };

    if (coverBoostProducts.length === 1) {
      clickObj.price0 = coverBoostProducts[0].annualPremium;
    }

    await root.$api.trackCoverBoostClick(clickObj);
  };

  const setCoverBoostClick = async (idx) => {
    if (previouslyClicked) {
      delete clickObj[previouslyClicked];
    }

    previouslyClicked = `clickPrice${idx}`;

    clickObj.coverBoostClicks = true;
    clickObj[previouslyClicked] = true;

    await root.$api.trackCoverBoostClick(clickObj);
  };

  const setClosed = () => {
    clickObj.coverBoostClicks = false;
    clickObj.coverBoostOffered = false;
  };

  return {
    setMoreInfoClick,
    setCoverBoostClick,
    setClosed,
  };
};
